/**
 * RepScorecardsRoute — skin-aware switcher for /rep-scorecards.
 * Cockpit → RepScorecardsCockpit · Classic → original RepScorecards
 */
import { useUISkin } from "@/data/UISkinContext";
import RepScorecards from "./RepScorecards";
import RepScorecardsCockpit from "./RepScorecardsCockpit";

export default function RepScorecardsRoute() {
  const { skin } = useUISkin();
  if (skin === "cockpit") return <RepScorecardsCockpit />;
  return <RepScorecards />;
}
